// Lives in its own file (not inline in catalogFeature.ts) so the route
// factory can import it without a circular import back through
// catalogFeature.ts -> presentation/routes -> here.
/**
 * The permission the legacy backend already issues for this screen
 * (`core.module_management.module_management_list.update`) — there is no
 * separate `.view` grant upstream, so holding the update permission is what
 * makes the feature and its price-edit action visible. Kept unchanged per
 * REBUILD-PLAN §5.3: no new namespace, no backend migration.
 */
export const MODULE_MANAGEMENT_UPDATE =
  "core.module_management.module_management_list.update";
